import {
    NgModule, Component, HostBinding, EventEmitter, Input,
    ChangeDetectionStrategy, ViewEncapsulation, AfterContentInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { coerceBooleanProperty } from '@angular/cdk/coercion';

import { EuiIconModule } from '../atoms';
import { BaseDirective } from '../../base.directive';
import { EuiLabelModule } from '../atoms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    templateUrl: './eui-alert.component.html',
    selector: 'div[euiAlert], eui-alert',
    styleUrls: ['./styles/_index.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class EuiAlertComponent extends BaseDirective implements AfterContentInit {

    @Input()
    get euiAlertMuted() { return this._euiAlertMuted; }
    set euiAlertMuted(value) { this._euiAlertMuted = coerceBooleanProperty(value); }
    _euiAlertMuted = false;

    @Input()
    isCloseable = false;

    @Output() close = new EventEmitter<null>();

    isVisible = true;

    @HostBinding('class')
    get cssClasses() {
        return [
            this.euiAlertMuted ? `eui-alert--muted` : ``,
            !this.isVisible ? `eui-alert--hidden` : ``,
            super.getCssClasses('eui-alert'),
        ].join(' ').trim();
    }

    constructor() {
        super();
    }

    ngAfterContentInit() {
        if (!this.e2eAttr) {
            this.e2eAttr = 'eui-alert';
        }
    }

    onCloseClick(event: Event) {
        this.isVisible = false;
        this.close.emit();
    }
}

@NgModule({
    imports: [
        CommonModule,
        EuiIconModule,
        EuiLabelModule,
        TranslateModule,
    ],
    declarations: [
        EuiAlertComponent,
    ],
    exports: [
        EuiAlertComponent,
    ],
})
export class EuiAlertModule { }
